/**
 * productResource — per-product variation for the invitation accept UI
 * (ADR-0010 M5c). The accept page core is identical for every product; only the
 * resource *noun* and the success deep-link change here, driven by `productId`.
 */

import { PRODUCTS } from '../config/products.js';

export function productById(productId: string) {
  return PRODUCTS.find((p) => p.id === productId);
}

/** Human noun for the shared resource, per product (falls back to the raw type). */
const RESOURCE_NOUN: Record<string, string> = {
  planner: 'project',
  invoice: 'workspace',
  qr: 'workspace',
  menu: 'menu',
  events: 'event',
  'link-page': 'page',
};

export function resourceNoun(productId: string, resourceType?: string): string {
  return RESOURCE_NOUN[productId] ?? resourceType ?? 'resource';
}

/**
 * Deep link into the product for an accepted resource. Planner is the M5c pilot
 * with a real `/projects/:id` route; other products fall back to their root until
 * each ships its own resource route. Returns `null` for an unknown product so the
 * UI shows "Go to Hub" instead of a broken link.
 */
export function resourcePath(productId: string, resourceId: string): string | null {
  const p = productById(productId);
  if (!p) return null;
  if (productId === 'planner') return `${p.url}/projects/${encodeURIComponent(resourceId)}`;
  return p.url;
}
